import { DocumentMedicalBillEntity } from '../../../generated-api';
import { ResultPageDocument } from '../defs/types';
import { MedicalBillStatsEntity } from './types';

export function medicalBillStatsGrouping(entity: ResultPageDocument<DocumentMedicalBillEntity>[]) {
  const result = entity.reduce<Record<string, MedicalBillStatsEntity>>((acc, curr) => {
    const {
      latest_revision: record,
      parsed_path: { fullFileName },
    } = curr;
    // 受診者, 医療機関 で groupBy して医療費の合計を計算する
    const key = `${record.patient_name}/${record.hospital_name}`;
    if (acc[key] == null) {
      acc[key] = {
        fileName: fullFileName,
        address: record.address?.trim(),
        hospitalName: record.hospital_name,
        patientName: record.patient_name,
        totalAmount: record.amount ?? 0,
        ...curr,
      };
    } else {
      acc[key].totalAmount += record.amount ?? 0;
      const addr = acc[key]?.address;
      // 住所の表示をまとめる
      // 文字数が少ないものを優先する
      if (addr != null && record.address != null && record.address.length < addr.length) {
        const trimmedAddr = record.address.trim();
        if (trimmedAddr.length > 0) {
          // 住所欄が空白でない場合のみ適用
          acc[key].address = trimmedAddr;
        }
      }
    }
    return acc;
  }, {});

  return Object.values(result).flatMap((a) => a);
}
